import type { SVGProps } from 'react'
const SvgSyTechSolidCatalog = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12.9 17.6c.3 1.2 1.4 2.1 2.7 2.1s2.8-1.3 2.8-2.8-1.3-2.8-2.8-2.8-2.4.9-2.7 2.1H5.6v1.5h7.3zm8.9 4.2H2.2V11.2h5.2L9 12.8h6l1.5-1.5h5.2v10.5zM7.9 17.6H6.4v1.5h1.5zm2.2 0H8.6v1.5h1.5zm4.1-.7c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4-.6-1.4-1.4-1.4-1.4.6-1.4 1.4" />
		<path fill="#e9e9e9" d="M11.2 12H9.4l-1.3-1.5H3.8v-3h7.4z" />
		<g fillOpacity={0.24}>
			<path d="M15.8 10.8 14.5 12H12V6.8H6V5.2h9.8z" />
			<path d="M20.2 10.5h-3.7v-6H9.8V3h10.4z" />
		</g>
	</svg>
)
export default SvgSyTechSolidCatalog
